import React from 'react';
import './Category.css';

function Category({ id, imgUrl, catName }) {
    return (
        <div className="category col-md-3 col-sm-12">
            <img classNAme="img-fluid" src={imgUrl} alt={`category ${catName}`} />
        </div>
    )
}

export default Category
